import React from "react";
import { Navigate } from "react-router-dom";
import { OnlyFor, ONLY_FOR } from "./types";
import { PATHNAMES } from "src/constants/routes";
import { useAppSelector } from "src/hooks/redux";
import { selectCurrentUserState } from "src/redux/currentUser/selector";
import { ScreenLoader } from "../Loader/ScreenLoader";

interface Props {
  component: React.FC;
  onlyFor?: OnlyFor;
  redirectUrl?: string;
}

export const PrivateRoute = ({
  component: Component,
  onlyFor = ONLY_FOR.AUTHORIZED,
  redirectUrl = PATHNAMES.HOME,
}: Props) => {
  const { isAuthorized, isLoading, currentUser } = useAppSelector(
    selectCurrentUserState
  );
  const { AGENT, AUTHORIZED, UNAUTHORIZED } = ONLY_FOR;

  const isUserAgent = isAuthorized && currentUser.host.role === AGENT;

  if (isLoading) return <ScreenLoader />;

  if (isUserAgent && onlyFor === AGENT) {
    return <Component />;
  }

  if (onlyFor === AUTHORIZED && isAuthorized) {
    return <Component />;
  }

  if (onlyFor === UNAUTHORIZED && !isAuthorized) {
    return <Component />;
  }

  return <Navigate to={redirectUrl} replace />;
};
